import { isNil } from 'lodash';
import { reach, Schema, AnyObject, Reference } from 'yup';

export function reachSchema<TParentSchema extends Schema, TOutput = unknown, TContext extends AnyObject = AnyObject>(
  schema: TParentSchema,
  path: string
): Schema<TOutput, TContext> {
  const result = reach(schema, path);

  if (isNil(result) || (result as Reference)?.__isYupRef) {
    throw new Error(`Could not resolve schema at path: ${path}`);
  }

  return result as Schema<TOutput, TContext>;
}
